var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.Temperature-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Temperature-st0",
    d: "M4.6,6.8H3.8c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h0.8C4.8,7.5,5,7.4,5,7.1C5,6.9,4.8,6.8,4.6,6.8z  M4.6,4.9H3.3c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h1.4C4.8,5.7,5,5.5,5,5.3C5,5.1,4.8,4.9,4.6,4.9z M4.6,3H3.8 C3.6,3,3.5,3.2,3.5,3.4s0.2,0.4,0.4,0.4h0.8C4.8,3.8,5,3.6,5,3.4C5,3.2,4.8,3,4.6,3z M4.6,1.2H3.3c-0.2,0-0.4,0.2-0.4,0.4 s0.2,0.4,0.4,0.4h1.4C4.8,1.9,5,1.7,5,1.5C5,1.3,4.8,1.2,4.6,1.2z M9.1,9.9L9.1,9.9c0,0.5-0.2,1.1-0.6,1.5C8.1,11.8,7.6,12,7,12 c-0.1,0-0.2,0-0.2,0c-0.5-0.1-1-0.3-1.4-0.8c-0.3-0.4-0.5-1-0.4-1.5c0.1-0.5,0.3-1,0.8-1.4v-7c0-0.3,0.1-0.7,0.4-0.9 C6.4,0.1,6.7,0,7.1,0S7.7,0.1,8,0.4S8.3,1,8.3,1.3v7C8.8,8.7,9.1,9.3,9.1,9.9L9.1,9.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.5e3f40ca98508c5b1f1e5fb969d0eb4e.svg";
export { ForwardRef as ReactComponent };